import { render } from "./workload.vue?vue&type=template&id=48e7f625&scoped=true"
import script from "./workload.vue?vue&type=script&lang=js"
export * from "./workload.vue?vue&type=script&lang=js"

import "./less/workloadVue.less?vue&type=style&index=0&id=48e7f625&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e7f625"]])

export default __exports__